export default "__VITE_ASSET__BKiiKmPw__"